module.exports = __webpack_public_path__ + "img/success-icon.0df0cc55.svg";